// extracted by mini-css-extract-plugin
export default {"spacing":"ClientDetailSkeleton_spacing__4fUR1","cardsDiv":"ClientDetailSkeleton_cardsDiv__81GV6"};